// Module
var code = `<div class="modal fade" id="confirmSolutionModal" tabindex="-1" role="dialog" data-bind="showModal: show">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div style="font-weight: bold; margin: 10px 0 5px 0" data-bind="label:'cc_P_YOUR_COMMENT'"></div>

        <textarea rows="6" style="width: 100%; border: 2px solid #3eb8a1" maxlength="2000" data-bind="value:comment">
        </textarea>
      </div>
      <div class="modal-footer">
        <div style="display: flex; align-items: center; justify-content: space-around">
          <button type="button" class="btn btn-default" data-bind="click: cancel, label: 'cc_P_CANCEL'"></button>
          <button type="button" class="btn btn-default" data-bind="click: confirm, label: confirmLabel"></button>
        </div>
      </div>
    </div>
  </div>
</div>
`;
// Exports
module.exports = code;